import './styles.scss';

import { IAccountOption } from '../../../../providers/venue-provider';

import { LegacyPnlBody } from './legacy-pnl-body';

interface LegacyPnlProps {
  accountOption: IAccountOption;
}

const LegacyPnl = ({ accountOption }: LegacyPnlProps) => {
  return (
    <div className="legacy-pnl-container">
      <LegacyPnlBody accountOption={accountOption} />
    </div>
  );
};

export default LegacyPnl;
